import React from 'react';
import cx from 'classnames';
import { resolveAdditionalInputComponent } from '../InputWrapper.helpers';
import styles from '../InputWrapper.module.scss';
export const InputWrapperAdditional = ({ additionalsProps: { showSeparator, size, ...rest }, append, prepend, }) => (<div {...rest} className={cx(styles.additional, styles[append ? 'append' : 'prepend'], {
        [styles.separator]: showSeparator,
    })} data-append-section={!!append || undefined} data-prepend-section={!!prepend || undefined}>
		{resolveAdditionalInputComponent({ item: append || prepend || '', size })}
	</div>);
